import { isEmbeddedWindow } from '@/utils/windowContext'
import type { AuthRecoveryReason } from './recovery'

const DESKTOP_BOT_ROUTE_NAMES = new Set(['bot-name', 'bot-session'])

/** CAS cannot render in an iframe, so framed desktop bots use popup sign-in. */
export function isFramedDesktopBotRoute(authSurface: 'embedded' | 'full', routeName: unknown): boolean {
  return authSurface === 'full' && DESKTOP_BOT_ROUTE_NAMES.has(String(routeName)) && isEmbeddedWindow()
}

/** LTI owns login on Canvas surfaces, so no CAS affordance may be offered there. */
export function usesLtiAuthentication(launchContext: unknown): boolean {
  return launchContext === 'lti_study' || launchContext === 'lti_assignment'
}

/** Whether a full-page CAS redirect, rather than an in-page prompt, handles a failure. */
export function casRedirectHandlesAuthFailure(
  reason: AuthRecoveryReason | undefined,
  authSurface: 'embedded' | 'full',
): boolean {
  return reason === 'auth_required' && authSurface === 'full' && !isEmbeddedWindow()
}

/** The one place route meta is read as a surface, so callers agree. */
export function authSurfaceOf(meta: { authSurface?: unknown }): 'embedded' | 'full' {
  return meta.authSurface === 'embedded' ? 'embedded' : 'full'
}
